import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { getBlobUrl } from '../../../../helpers/getBlobUrl';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import styles from './ImgPreview.module.scss';

const ImgPreview = ({
  imgData,
  className,
  containerRef,
  onPreviewClick,
  useImgQuery,
  queryFnData = {},
  queryOptions = {},
}) => {
  const rootRef = useRef();

  const [url, setUrl] = useState('');
  const [enabled, setEnabled] = useState(false);

  const { data: imgStr, isFetching: isImgStrFetching } = useImgQuery(
    { ...imgData, ...queryFnData },
    {
      staleTime: Infinity,
      enabled,
      ...queryOptions,
    }
  );

  const handleIntersect = async ([{ isIntersecting }], observerElement) => {
    if (isIntersecting) {
      setEnabled(true);
      observerElement.unobserve(rootRef.current);
    }
  };

  useIntersectionObserver({
    containerRef,
    target: rootRef,
    onIntersect: handleIntersect,
  });

  useEffect(() => {
    let newUrl = '';

    if (imgStr?.trim() !== '') {
      newUrl = getBlobUrl(imgStr);
    }

    setUrl(newUrl);
  }, [imgStr]);

  return (
    <div
      ref={rootRef}
      className={cn(styles.root, className, {
        [styles.skeleton]: isImgStrFetching,
      })}
    >
      {url && (
        <img
          className={styles.img}
          src={url}
          alt={imgData.name}
          onClick={onPreviewClick}
        />
      )}
    </div>
  );
};

export default ImgPreview;
